<template>
	<div class="account">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<el-row type="flex" class="row-bg" justify="space-between">
			<h2 style="margin: 0">总数: {{ page.totalRecords }}</h2>
		</el-row>
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="column"
			:loading="loading"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<!-- 编辑弹框 -->
		<el-dialog
			:title="mediaForm.id ? '编辑客户媒体' : '新建客户媒体'"
			:close-on-click-modal="false"
			:visible.sync="dialogVisible"
			width="600px"
			@close="close"
		>
			<div>
				<el-form
					:model="mediaForm"
					ref="mediaForm"
					label-width="150px"
					size="medium"
					style="padding-right: 20px"
				>
					<el-form-item label="客户名称" prop="custName">
						<span>{{ mediaForm.custName }}</span>
					</el-form-item>
					<!-- <el-form-item label="社媒主体" prop="subject">
								<span>{{ mediaForm.subject }}</span>
							</el-form-item> -->
					<el-form-item label="服务单号" prop="serviceCode">
						<span>{{ mediaForm.serviceCode }}</span>
					</el-form-item>
					<el-form-item label="套餐类型" prop="setMealName">
						<span>{{ mediaForm.setMealName }}</span>
					</el-form-item>
					<el-form-item label="服务人员" prop="serviceStaffId">
						<user-search v-model="mediaForm.serviceStaffId"></user-search>
					</el-form-item>
					<el-form-item label="服务到期时间" prop="expirationTime">
						<el-date-picker
							v-model="mediaForm.expirationTime"
							format="yyyy.MM.dd"
							value-format="yyyy.MM.dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="当月任务" prop="taskCount">
						<el-input v-model="mediaForm.taskCount"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirm" :loading="btnLoading">确认</el-button>
			</div>
		</el-dialog>

		<!-- 平台绑定弹窗 -->
		<el-dialog
			title="平台绑定"
			:close-on-click-modal="false"
			:visible.sync="bindDialogVisible"
			width="600px"
			custom-class="bindDialog"
			@close="bindDialogClose"
		>
			<div>
				<el-form
					:model="platformBindForm"
					label-width="150px"
					size="medium"
					style="padding-right: 20px"
				>
					<el-form-item label="Facebook主页" prop="custFacebookPageId">
						<sky-select
							:options="facebookCustOptions"
							filterable
							remote
							:customOption="true"
							placeholder="输入主页名称或主页id可模糊查询"
							:props="{ label: 'pageName', value: 'pageId' }"
							v-model="platformBindForm.custFacebookPageId"
						></sky-select>
						<el-button type="primary" :loading="checkLoading" @click="pageRetrieve"
							>检索刷新主页</el-button
						>
					</el-form-item>
					<div class="tips">
						提示：初次绑定或更换主页后，需要配置聊天插件并完成发布，否则聊天功能将不能正常使用
					</div>
					<el-form-item
						label="X（Twitter）"
						prop="xpageId"
						v-if="platformBindForm.versionType === 1"
					>
						<el-input v-model="platformBindForm.xpageName"></el-input>
						<el-button type="primary" @click="oauthAccount(27)" :disabled="inBindLoading"
							>绑定主页</el-button
						>
					</el-form-item>
					<el-form-item
						label="Linkedin主页"
						prop="linkedinPageId"
						v-if="platformBindForm.versionType === 1"
					>
						<el-input v-model="platformBindForm.linkedinPageName"></el-input>
						<el-button type="primary" @click="oauthAccount(25)" :disabled="inBindLoading"
							>绑定主页</el-button
						>
					</el-form-item>
					<el-form-item
						label="YouTube频道"
						prop="youTubePageId"
						v-if="platformBindForm.versionType === 1"
					>
						<el-input v-model="platformBindForm.youTubePageName"></el-input>
						<el-button type="primary" @click="oauthAccount(28)" :disabled="inBindLoading"
							>绑定主页</el-button
						>
					</el-form-item>
					<el-form-item
						label="TikTok频道"
						prop="tikTokPageId"
						v-if="platformBindForm.versionType === 1"
					>
						<el-input v-model="platformBindForm.tikTokPageName"></el-input>
						<el-button type="primary" @click="oauthAccount(29)" :disabled="inBindLoading"
							>绑定主页</el-button
						>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<el-button @click="bindDialogVisible = false">取消</el-button>
				<el-button
					type="primary"
					@click="platformBind"
					:loading="btnLoading"
					:disabled="inBindLoading"
					>确认</el-button
				>
			</div>
		</el-dialog>

		<el-dialog title="任务考核" :visible.sync="taskDialog">
			<div>
				<h2 style="text-align: center">{{ company }}</h2>
				<div class="block" style="text-align: center">
					<el-date-picker
						@change="change"
						value-format="yyyy-MM-dd"
						v-model="month"
						type="month"
						placeholder="选择月"
					></el-date-picker>
				</div>
				<el-row>
					<el-col :span="16">
						<div ref="echarts" style="height: 400px"></div>
					</el-col>
					<el-col :span="8">
						<div>
							<h3>完成率: {{ count.sendCountRate }}</h3>
						</div>
						<div>已发: {{ count.sendCount }}</div>
						<div>待发: {{ count.waitCount }}</div>
						<div>未发: {{ count.unissuedCount }}</div>
						<div>任务: {{ count.taskCount }}</div>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
		<el-dialog title="绑定首页" :visible.sync="pageDialog" width="600px">
			<sky-select
				:options="pageList"
				v-model="selectPageId"
				:props="{ label: 'name', value: 'id' }"
			></sky-select>
			<div slot="footer">
				<el-button @click="pageDialog = false">取消</el-button>
				<el-button type="primary" @click="sendReport">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import moment from 'dayjs';
import echarts from 'echarts/lib/echarts';
// 引入柱状图
import 'echarts/lib/chart/pie';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';

import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import mediafax from '@/backend/services/account/mediafax';
import account from '@/backend/services/account/account';
import tweets from '@/backend/services/account/tweets';
import { mediaPlatForm, packageList, statusList } from '@/common/dictionary';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import skyMedia from '@/components/iglobalwin/formComponents/account/sky-media.vue';
import customerMinxins from '@/mixins/customer';
import userSearch from '@/components/tools/userSearch.vue';
const page = listPageCreate({
	searchConfig: {
		api: api.mediafax.getMediafaxList,
		method: 'POST',
	},
});
export default {
	name: 'socialMedialAccount',
	props: {},
	components: {
		filterPanel,
		skySelect,
		skyMedia,
		userSearch,
	},
	data() {
		const that = this;
		const groups = {
			others: [
				{
					tagName: 'sky-select',
					placeholder: '输入客户FB主页ID或主页名称查询',
					label: '客户FB主页',
					prop: 'pageId',
					value: null,
					props: {
						label: 'pageName',
						value: 'pageId',
					},
					filterable: true,
					customOption: true,
					options: [],
				},
				{
					tagName: 'sky-input',
					placeholder: '服务人员',
					label: '服务人员',
					prop: 'serviceStaffName',
					value: '',
					filterable: true,
					remote: false,
				},
			],
			multiples: [
				{
					defaultText: '客户类型',
					label: '客户类型',
					prop: 'versionType',
					options: [
						{
							label: 'Pro用户',
							value: 1,
						},
						{
							label: '标准用户',
							value: 0,
						},
					],
					value: '',
				},
				{
					defaultText: '任务类型',
					label: '任务类型',
					prop: 'taskType',
					options: [
						{
							label: '仅查看任务未完成',
							value: 0,
						},
						{
							label: '仅查看任务已完成',
							value: 1,
						},
					],
					value: '',
				},
			],
		};
		const column = [
			{
				type: 'custInfo',
				label: '客户名称',
				main: 'custName',
				minWidth: 140,
			},
			{
				label: '权限版本名称',
				bind: 'versionName',
			},
			{
				label: '服务单号',
				type: 'custInfo',
				width: 180,
				disabled: true,
				align: 'center',
				text: [
					{
						bind: 'serviceCode',
						style: {
							'text-align': 'center',
						},
					},
				],
			},
			{
				label: '服务到期',
				bind: 'expirationTime',
				align: 'center',
			},
			{
				type: 'iconbutton',
				label: '社媒平台',
				iconlist: [
					// 社媒平台对接
					{
						id: 0,
						name: 'facebook1',
						style: row => {
							let { platformPageList } = row;
							if (
								platformPageList &&
								platformPageList.some(item => {
									return item.businessCode == '26';
								})
							) {
								return { color: '#0766ff', cursor: 'pointer' };
							}
							return { color: '#a8a6a6', cursor: 'not-allowed' };
						},
						message: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '26';
							});
							if (obj) return obj.pageName;
						},
						callback: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '26';
							});
							window.open(obj.pageUrl);
						},
					},
					{
						id: 1,
						name: 'twitter1',
						style: row => {
							let { platformPageList } = row;
							if (
								platformPageList &&
								platformPageList.some(item => {
									return item.businessCode == '27';
								})
							) {
								return { color: '#000', cursor: 'pointer' };
							}
							return { color: '#a8a6a6', cursor: 'not-allowed' };
						},
						message: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '27';
							});
							if (obj) return obj.pageName;
						},
						callback: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '27';
							});
							window.open(obj.pageUrl);
						},
						showButton: row => {
							let { versionType } = row;
							return versionType === 1;
						},
					},
					{
						id: 2,
						name: 'linkedin1',
						style: row => {
							let { platformPageList } = row;
							if (
								platformPageList &&
								platformPageList.some(item => {
									return item.businessCode == '25';
								})
							) {
								return { color: '#0b66c2', cursor: 'pointer' };
							}
							return { color: '#a8a6a6', cursor: 'not-allowed' };
						},
						message: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '25';
							});
							if (obj) return obj.pageName;
						},
						callback: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '25';
							});
							window.open(obj.pageUrl);
						},
						showButton: row => {
							let { versionType } = row;
							return versionType === 1;
						},
					},
					{
						id: 3,
						name: 'youtube2',
						style: row => {
							let { platformPageList } = row;
							if (
								platformPageList &&
								platformPageList.some(item => {
									return item.businessCode == '28';
								})
							) {
								return { color: '#ff0000', cursor: 'pointer' };
							}
							return { color: '#a8a6a6', cursor: 'not-allowed' };
						},
						message: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '28';
							});
							if (obj) return obj.pageName;
						},
						callback: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '28';
							});
							window.open(obj.pageUrl);
						},
						showButton: row => {
							let { versionType } = row;
							return versionType === 1;
						},
					},
					{
						id: 4,
						name: 'tikTok',
						style: row => {
							let { platformPageList } = row;
							if (
								platformPageList &&
								platformPageList.some(item => {
									return item.businessCode == '29';
								})
							) {
								return { color: '#000', cursor: 'pointer' };
							}
							return { color: '#a8a6a6', cursor: 'not-allowed' };
						},
						message: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '29';
							});
							if (obj) return obj.pageName;
						},
						callback: row => {
							let { platformPageList } = row;
							let obj = platformPageList.find(item => {
								return item.businessCode == '29';
							});
							window.open(obj.pageUrl);
						},
						showButton: row => {
							let { versionType } = row;
							return versionType === 1;
						},
					},
				],
				minWidth: 150,
			},
			{
				label: '服务人员',
				bind: 'serviceStaffName',
			},
			{
				type: 'taskComplete',
				label: '当月任务',
				main: function (row) {
					return row.tweetsCountVO.sendCountRate;
				},
				sort: 'current',
				options: [
					{
						label: '由高到低',
						value: 'desc',
					},
					{
						label: '由低到高',
						value: 'asc',
					},
				],
				complete: function (row) {
					let { tweetsCountVO } = row;
					let { sendCount, waitCount, taskCount } = tweetsCountVO;
					return `${sendCount || 0}/${waitCount}/${taskCount}`;
				},
				event: function (row) {
					that.mediafaxId = row.id;
					that.company = row.custName;
					that.month = moment().format('YYYY-MM-DD');
					that.getReport();
				},
				align: 'right',
				minWidth: 160,
			},
			{
				label: '本月发报',
				bind: 'reportCount',
				align: 'center',
				width: 70,
			},
			{
				type: 'btnClick',
				label: '操作',
				align: 'center',
				minWidth: 300,
				bind(row) {
					let { platformPageList } = row;
					// if (platformPageList && platformPageList.length !== 0) {
					// 	return platformPageList.some(item => {
					// 		return item.businessCode == '26';
					// 	})
					// 		? that.operateBtn.fb
					// 		: that.operateBtn.others;
					// } else {
					// 	return [];
					// }

					return that.operateBtn.fb;
				},
			},
		];
		const reportData = {
			companyName: {
				label: '公司名称',
				formType: 'sky-span',
				value: '上海天擎信息技术',
			},
			reportCount: {
				label: '本月发送报告次数',
				formType: 'sky-span',
				value: '2次',
			},
			lastDate: {
				label: '上次发送日期',
				formType: 'sky-span',
				value: '上次发送日期',
			},
			facebookFollow: {
				label: 'Facebook关注度',
				formType: 'sky-input',
				value: '',
			},
			twitterFollow: {
				label: 'twitter关注度',
				formType: 'sky-input',
				value: '',
			},
			linkedInFollow: {
				label: 'linkedIn关注度',
				formType: 'sky-input',
				value: '',
			},
		};
		return {
			company: '',
			month: moment().format('YYYY-MM-DD'),
			groups: groups,
			column: column,
			packageList: packageList,
			mediaPlatForm: mediaPlatForm,
			platform: [],
			dialogVisible: false,
			bindDialogVisible: false,
			reportVisible: false,
			taskDialog: false,
			btnLoading: false,
			pageDialog: false,
			selectPageId: '',
			pageList: [],
			facebookCustOptions: [],
			id: '',
			mediafaxId: '',
			mediaForm: {},
			platformBindForm: {
				id: '',
				custFacebookPageId: '',
				linkedinPageId: '',
				linkedinPageName: '',
				xpageId: '',
				xpageName: '',
				youTubePageId: '',
				youTubePageName: '',
				tikTokPageId: '',
				tikTokPageName: '',
			},
			platformBindList: [],
			custFacebookPageIdCopy: '',
			count: {},
			reportData: reportData,
			operateBtn: {
				fb: [
					{
						text: '服务编辑',
						showButton() {
							return that.getPermission(that.$permissionData.socialMediaUpdate.englishName);
						},
						trigger: function (row) {
							that.editMedia(row);
						},
					},
					{
						text: '平台绑定',
						trigger: function (row) {
							let { platformPageList, id, versionType } = row;
							let facebookObj = platformPageList.find(item => {
								return item.businessCode == '26';
							});
							let twitterObj = platformPageList.find(item => {
								return item.businessCode == '27';
							});
							let linkedinObj = platformPageList.find(item => {
								return item.businessCode == '25';
							});
							let youtubeObj = platformPageList.find(item => {
								return item.businessCode == '28';
							});
							let tikTokObj = platformPageList.find(item => {
								return item.businessCode == '29';
							});
							that.platformBindForm = {
								id,
								versionType,
								custFacebookPageId: facebookObj ? facebookObj.pageId : '',
								linkedinPageId: linkedinObj ? linkedinObj.pageId : '',
								linkedinPageName: linkedinObj ? linkedinObj.pageName : '',
								xpageId: twitterObj ? twitterObj.pageId : '',
								xpageName: twitterObj ? twitterObj.pageName : '',
								youTubePageId: youtubeObj ? youtubeObj.pageId : '',
								youTubePageName: youtubeObj ? youtubeObj.pageName : '',
								tikTokPageId: tikTokObj ? tikTokObj.pageId : '',
								tikTokPageName: tikTokObj ? tikTokObj.pageName : '',
							};
							that.custFacebookPageIdCopy = facebookObj ? facebookObj.pageId : '';
							that.platformBindList = [];
							that.bindDialogVisible = true;
						},
					},
					{
						text: '查看推文',
						trigger: function (row) {
							that.previewTwitter(row);
						},
					},
				],
				others: [
					{
						text: '服务编辑',
						showButton() {
							return that.getPermission(that.$permissionData.socialMediaUpdate.englishName);
						},
						trigger: function (row) {
							that.editMedia(row);
						},
					},
					{
						text: '平台绑定',
						trigger: function (row) {
							that.bindDialogVisible = true;
						},
					},
				],
			},
			checkLoading: false,
			inBindLoading: false,
		};
	},
	mixins: [page, customerMinxins, beforeRouteEnter],
	computed: {
		editRules() {
			let rules = {};
			let plat = {
				operationFacebookAccountId: [
					{
						required: true,
						message: '请选择FaceBook运营账号',
						trigger: 'change',
					},
				],
				custFacebookPageId: [
					{
						required: true,
						message: '请选择FaceBook客户账号',
						trigger: 'change',
					},
				],
				custTwitterAccount: [
					{
						required: false,
						message: '请输入Twitter客户账号',
						trigger: 'blur',
					},
				],
				custLinkedInPageId: [
					{
						required: false,
						message: '请输入LinkedIn客户账号',
						trigger: 'blur',
					},
				],
			};
			if (this.mediaForm && this.mediaForm.platformList) {
				this.mediaForm.platformList.map(item => {
					if (item == '26') {
						rules.operationFacebookAccountId = plat.operationFacebookAccountId;
						rules.custFacebookPageId = plat.custFacebookPageId;
					} else if (item == '27') {
						rules.custTwitterAccount = plat.custTwitterAccount;
					} else {
						rules.custLinkedInPageId = plat.custLinkedInPageId;
					}
				});
			}
			return rules;
		},
		echartsData() {
			return {
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b} : {c} ({d}%)',
				},
				series: [
					{
						name: '任务考核',
						type: 'pie',
						radius: '55%',
						center: ['50%', '60%'],
						data: [
							{ value: this.count.sendCount, name: '已发' },
							{ value: this.count.waitCount, name: '待发' },
							{ value: this.count.unissuedCount, name: '未发' },
						],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)',
							},
						},
						label: {
							show: true,
							formatter: '{b} : {c} ({d}%)',
						},
					},
				],
			};
		},
	},
	mounted() {
		this.getPageList(' ');
	},
	methods: {
		editMedia(row) {
			let { id, custName } = row;
			mediafax.getMediafaxDetail({ id }).then(val => {
				this.mediaForm = {
					custName,
					...val.data,
				};
				this.dialogVisible = true;
			});
		},
		previewTwitter(row) {
			this.$store.commit('SET_CUSTOMERID', row.customerId);
			this.$store.commit('SET_CUSOMERNAME', row.custName);
			this.$router.push({
				name: 'socialMedialTweets',
				query: {
					id: row.customerId,
					custName: encodeURIComponent(row.custName),
				},
			});
		},
		change(val) {
			this.month = val;
			this.getReport();
		},
		getReport() {
			const that = this;
			let obj = {
				serviceId: that.mediafaxId,
				date: that.month,
			};
			tweets.getCount(obj).then(val => {
				that.count = val.data;
				that.taskDialog = true;
				that.$nextTick(function () {
					let element = that.$refs.echarts;
					that.myChart = echarts.init(element);
					that.myChart.setOption(that.echartsData);
				});
			});
		},
		sendReport() {
			mediafax.bindPage({ id: this.id, platform: '25', pageId: this.selectPageId }).then(val => {
				if (val.data == 200) {
					this.$message.success('绑定成功');
					this.pageDialog = false;
					this.query();
				}
			});
		},
		async getPageList(queryParam) {
			let res = await mediafax.getPageList({ search: queryParam });
			if (res) {
				this.facebookCustOptions = res.data || [];
				this.groups.others[0].options = res.data || [];
			} else {
				this.facebookCustOptions = [];
				this.groups.others[0].options = [];
			}
		},
		getItemStatusName(status) {
			if (status) {
				return statusList[status].label;
			}
		},
		getItemStatus(status) {
			if (status) {
				return statusList[status].className;
			}
		},
		auth(row, platform) {
			//        window.open('https://www.linkedin.com/m/logout')
			mediafax
				.getAuthUrl({
					id: row.id,
					platform: platform,
					url: location.href,
				})
				.then(val => {
					if (val.data) {
						location.href = val.data;
					}
				});
		},
		close() {
			this.mediaForm = {};
		},
		confirm() {
			this.$refs.mediaForm.validate(vaild => {
				if (vaild) {
					this.btnLoading = true;
					let obj = _.assign({}, this.mediaForm);
					let request = mediafax.addMediafax;
					let msg = '新增成功!';
					if (this.mediaForm.id) {
						request = mediafax.editMediafax;
						msg = '修改成功';
						delete obj.custName;
						delete obj.packageType;
						delete obj.creater;
						delete obj.current;
						delete obj.operatorName;
						delete obj.id;
						delete obj.serviceId;
						delete obj.serviceCode;
						delete obj.subject;
						delete obj.setMealName;
						delete obj.platformList;
					}
					request({ id: this.mediaForm.id }, obj)
						.then(() => {
							this.$message({
								message: msg,
								type: 'success',
							});
							this.btnLoading = false;
							this.dialogVisible = false;
							this.query();
						})
						.catch(() => {
							this.btnLoading = false;
						});
				}
			});
		},
		getFacebookAccount() {
			return this.getPlatForm(26);
		},
		getTwitterAccount() {
			return this.getPlatForm(25);
		},
		getPlatForm(type) {
			return account.getPlatFormAccount({ businessCode: type }).then(val => {
				return val.data;
			});
		},
		pageRetrieve() {
			this.checkLoading = true;
			mediafax
				.getPageRetrieve()
				.then(() => {
					this.checkLoading = false;
					this.getPageList(' ');
					this.$message.success('检索成功');
				})
				.catch(() => {
					this.checkLoading = false;
				});
		},
		// 返回授权链接
		async oauthAccount(businessCode) {
			let { platformBindForm } = this;
			let { id } = platformBindForm;
			let res = await mediafax.oauthAccount({ id, businessCode });
			let newWindow;

			this.inBindLoading = true;

			newWindow = window.open(res.data, '_blank', 'width=800,height=600,top=50,left=100');

			if (newWindow) {
				// 检查新窗口是否被关闭
				let checkWindowClosed = setInterval(() => {
					if (newWindow.closed) {
						clearInterval(checkWindowClosed);
						this.newWindowClosedAfter(id, businessCode);
					}
				}, 1000); // 每秒检查一次
			} else {
				console.error('Failed to open new window.');
			}
		},
		// 新窗口关闭后
		async newWindowClosedAfter(id, businessCode) {
			try {
				let res = await mediafax.oauthBind({ id, businessCode });
				if (res.data) {
					let { pageId, pageName } = res.data;
					if (businessCode == '27') {
						this.platformBindForm.xpageId = pageId;
						this.platformBindForm.xpageName = pageName;
						this.platformBindList.push('xpageId');
					}
					if (businessCode == '25') {
						this.platformBindForm.linkedinPageId = pageId;
						this.platformBindForm.linkedinPageName = pageName;
						this.platformBindList.push('linkedinPageId');
					}
					if (businessCode == '28') {
						this.platformBindForm.youTubePageId = pageId;
						this.platformBindForm.youTubePageName = pageName;
						this.platformBindList.push('youTubePageId');
					}
					if (businessCode == '29') {
						this.platformBindForm.tikTokPageId = pageId;
						this.platformBindForm.tikTokPageName = pageName;
						this.platformBindList.push('tikTokPageId');
					}
				}
				this.inBindLoading = false;
			} catch (error) {
				this.inBindLoading = false;
			}
		},
		// 平台绑定
		async platformBind() {
			try {
				this.btnLoading = true;
				let { platformBindForm, platformBindList } = this;
				let { versionType, id } = platformBindForm;
				let obj = {};

				if (versionType == 1) {
					platformBindList.forEach(key => {
						obj[key] = platformBindForm[key];
					});
				}

				// obj['custFacebookPageId'] = custFacebookPageId;

				let res = await mediafax.platformBind({
					id,
					...obj,
				});
				if (res) {
					this.btnLoading = false;
					this.bindDialogVisible = false;
					this.query();
				}
			} catch (error) {
				this.btnLoading = false;
			}
		},
		// 绑定弹窗关闭回调
		bindDialogClose() {
			this.inBindLoading = false;
			this.btnLoading = false;
		},
	},
};
</script>
<style lang="scss" scoped>
.account {
	.row-bg {
		background: #fff;
		margin: 10px 0;
		padding: 10px;
	}

	::v-deep .icon-btn {
		justify-content: flex-start;
	}

	::v-deep .bindDialog {
		.el-dialog__body {
			.el-form {
				.el-form-item {
					.el-form-item__content {
						display: flex;

						.el-button {
							margin-left: 10px;
						}
					}
				}

				.tips {
					margin: 15px 50px;
					font-size: 13px;
				}
			}
		}
	}
}
</style>

<style lang="scss">
.dialogScroll {
	height: 100%;

	& > .el-scrollbar__wrap {
		overflow-x: hidden;
	}
}

.tips {
	padding-left: 45px;
	line-height: 20px;
}
</style>
